import type { StudyReportVersion } from '../../../types/studyTimeline';
import { StatusBadge } from '../StatusBadge';
import { STATUS_CONFIG, STATUS_PRIORITY } from '../reportStatusConfig';
import styles from './ReportBadges.module.css';

interface ReportBadgesProps {
  reports: StudyReportVersion[];
}

export default function ReportBadges({ reports }: ReportBadgesProps) {
  if (reports.length === 0) {
    return (
      <div className={styles.badges}>
        <StatusBadge variant="muted" label="No Report" />
      </div>
    );
  }

  const uniqueStatuses = STATUS_PRIORITY.filter((status) =>
    reports.some((r) => r.status === status)
  );

  return (
    <div className={styles.badges}>
      {uniqueStatuses.map((status) => (
        <StatusBadge
          key={status}
          variant={STATUS_CONFIG[status].variant}
          label={STATUS_CONFIG[status].label}
        />
      ))}
    </div>
  );
}
